/* 鄧艾（字士載） */
import { gd, landing, spMul } from '../../core/kit.ts';
import { defineHero, hook, S, D } from '../define.ts';

export default defineHero({
  id: 'dengai', name: '鄧艾', sub: '字士載', faction: 'wei', role: '刺客', weapon: 'spear',
  look: { beard: 'goatee', fx: '#d8c08a', c: { plume: '#8a6a3a', cape: '#5a4a30' } },
  skills: [
    ['裹氈滾下', 'dash', '裹起氈毯高速滾動 {1.5/2/2.5/3} 秒（移速 +85%、不受緩速），撞到第一名敵將時停下，造成 {90/140/190/240} 傷害並擊飛 1 秒。', { x: { k: 'roll', ms: 85, dur: [1.5, 2, 2.5, 3], dmg: [90, 140, 190, 240] }, aim: S(0), cd: [16, 14, 12, 10], mp: 70, el: 'earth' }],
    ['艾艾', 'multi', '連斬兩下，每下 {70/110/150/190} 傷害；第二下對背對鄧艾的敵人（正在逃跑）傷害 +50%。', { x: { k: 'aiai', dmg: [70, 110, 150, 190], r: 160 }, aim: D(160, 60), cd: 7, mp: [50, 55, 60, 65], el: null }],
    ['屯田', 'passive', '每秒多 {1/1.5/2/2.5} 金；每 30 秒多 {1/2/3/4} 木。', { pv: {}, sig: 'farm', gold: [1, 1.5, 2, 2.5], wood: [1, 2, 3, 4] }],
    ['偷渡陰平', 'blink', '選一個極遠的地點（{2400/3000/3600}），隱身疾行 2 秒，無視樹林、河流直接抵達；落地時周圍敵人受到 {200/300/400} 傷害並緩速 50%。', { x: { k: 'yinping', dmg: [200, 300, 400], r: 220, travel: 2 }, aim: { kind: 'point', range: [2400, 3000, 3600], area: 220 }, cd: [110, 95, 80], mp: [150, 175, 200], el: 'earth', shout: '偷渡陰平，直取成都！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    roll(u, a, X) {
      u.rollT = this.t + X.dur; u.rollDmg = X.dmg * spMul(u);
      this.addBuff(u, { id: 'roll', t: X.dur, ms: X.ms / 100 }); // v0.4.2.1：翻倍 → +85%（移速上限 480）
      this.fx({ k: 'puff', x: u.x, y: u.y });
    },
    aiai(u, a, X) {
      const sp = spMul(u), hit = (j: number) => this.cone(u, a.dir, X.r, 0.55).forEach((t) => {
        const flee = j && !t.structure && t.f === Math.sign(t.x - u.x); // 背對鄧艾
        this.damage(u, t, X.dmg * sp * (flee ? 1.5 : 1) * (t.structure ? 0.5 : 1), { magic: true, spell: true, stagger: 0.3 });
        if (flee && (u.human || t.human)) this.dmgEvents.push({ x: t.x, y: t.y - 50, text: '艾艾', team: t.team, src: u.id, tgt: t.id });
      });
      hit(0); this.later(0.3, () => { if (u.alive && u.st.stun <= 0) hit(1); });
    },
    yinping(u, a, X) {
      u.yp = { x0: u.x, y0: u.y, x1: a.pt[0], y1: a.pt[1], t0: this.t, dur: X.travel, dmg: X.dmg * spMul(u), r: X.r };
      u.slashing = true; u.invuln = true; u.st.invis = X.travel + 0.2; u.act = null; u.anim = 'run'; u.animSeq++;
      this.fx({ k: 'puff', x: u.x, y: u.y });
      this.fx({ k: 'warn', x: a.pt[0], y: a.pt[1], r: X.r, t: X.travel });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 屯田：持續加錢，每 30 秒加木頭
    hook('tick', 50, function (u, dt) { const g = u.sg; if (g && g.farm) { u.gold += g.farm.v('gold') * dt; if ((u.farmT = (u.farmT || 0) + dt) >= 30) { u.farmT = 0; u.wood = (u.wood || 0) + g.farm.v('wood'); } } }),
    // 裹氈滾下：不受緩速，撞到敵將就停
    hook('tick', 70, function (u, dt) {
      if (u.rollT > this.t) {
        u.st.slow = 0;
        const t = this.units.find((o) => o.kind === 'hero' && o.alive && this.hostile(u, o) && gd(u.x, u.y, o.x, o.y) < u.r + o.r + 14);
        if (t) {
          u.rollT = 0; this.addBuff(u, { id: 'roll', t: 0.01 });
          this.damage(u, t, u.rollDmg, { magic: true, spell: true, stagger: 0.4 }); this.applyCC(u, t, { knockup: 1 });
          this.fx({ k: 'slam', x: t.x, y: t.y, col: '#d8c08a' });
        }
      }
    }),
    // 偷渡陰平：疾行中
    hook('tick', 80, function (u, dt) {
      const yp = u.yp;
      if (yp) {
        const k = Math.min(1, (this.t - yp.t0) / yp.dur);
        if (k < 1) { u.x = yp.x0 + (yp.x1 - yp.x0) * k; u.y = yp.y0 + (yp.y1 - yp.y0) * k; u.f = Math.sign(yp.x1 - yp.x0) || u.f; u.st.invis = Math.max(u.st.invis, 0.2); }
        else {
          u.yp = null; u.slashing = false; u.invuln = false; u.st.invis = 0;
          const q = landing(yp.x0, yp.y0, yp.x1, yp.y1); u.x = q[0]; u.y = q[1];
          this.enemiesNear(u, u.x, u.y, yp.r).forEach((t) => { if (t.structure) return; this.damage(u, t, yp.dmg, { magic: true, spell: true, stagger: 0.4 }); this.applyCC(u, t, { slow: [0.5, 2] }); });
          this.fx({ k: 'slam', x: u.x, y: u.y, col: '#d8c08a' }); this.fx({ k: 'puff', x: u.x, y: u.y });
        }
      }
    }),
    hook('revive', 20, function (u) { if (u.yp) u.slashing = false; u.yp = null; u.rollT = 0; }),
  ],
  // 電腦什麼時候放這招
  ai: {
    roll: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d > 200 && d < 800,
    yinping: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d > 250 && d < 900,
  },
});
